/* Copyright (c) 2017 Backpack Health LLC */

import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import MfaSetMobileNumber from './MfaSetMobileNumber';
import { getEnableMfaFlowData, getActiveProfileDefaultCountryISO2 } from '../../redux/reduxSelectors';
import { selectors as listSelectors } from '../../../redux/ducks/lists/lists';

import { EnableMfaFlowActions } from '../../redux/userFlowActions';
import NavigationActions, { navigateBack } from '../../redux/NavigationActions';

import RouteNames from '../../RouteNames';

function mapStateToProps(state, routerProps) {
  const { history, intl } = routerProps;
  const enableMfaData = getEnableMfaFlowData(state);
  const defaultCountryIso2 = getActiveProfileDefaultCountryISO2(state);
  return {
    mfaEnableIsInitated: enableMfaData.isInit,
    mobileNumber: enableMfaData.mobileNumber,
    mobileNumberSubmitted: enableMfaData.mobileNumberSubmitted,
    country: enableMfaData.country || defaultCountryIso2,
    countryOptions: listSelectors.getCountryCollection(state)
      .map((c) => ({ labelId: c.key, value: c.iso2 }))
      .sort((a, b) => {
        const firstCountryName = intl.formatMessage({ id: a.labelId });
        const secondCountryName = intl.formatMessage({ id: b.labelId });
        return firstCountryName < secondCountryName ? -1 : 1;
      }),
    loadInitialData: () => {},
    goToVerify: () => {
      NavigationActions.goTo(history, RouteNames.mfaVerifyMobileNumber());
    },
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onChangeMobileNumber: (formattedNumber, isValid) => {
      dispatch(EnableMfaFlowActions.mobileNumber(formattedNumber, isValid));
    },
    onChangeCountry: (countryCode) => {
      dispatch(EnableMfaFlowActions.country(countryCode));
    },
    submitMobileNumber: (callback) => {
      dispatch(EnableMfaFlowActions.submitMobileNumber(callback));
    },
    goBack: () => {
      dispatch(EnableMfaFlowActions.reset());
      navigateBack(RouteNames.accountSettings());
    }
  };
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(MfaSetMobileNumber));
